/**
 * Constants enumerating the HTTP status codes.
 *
 * All status codes defined in RFC1945 (HTTP/1.0, RFC2616 (HTTP/1.1),
 * and RFC2518 (WebDAV) are supported.
 *
 * Based on the org.apache.commons.httpclient.HttpStatus Java API.
 *
 * Ported by Bryce Neal.
 */
export const UtilHttpStatus = {
    ACCEPTED: 202,
    BAD_GATEWAY: 502,
    BAD_REQUEST: 400,
    CONFLICT: 409,
    CONTINUE: 100,
    CREATED: 201,
    EXPECTATION_FAILED: 417,
    FORBIDDEN: 403,
    GATEWAY_TIMEOUT: 504,
    GONE: 410,
    HTTP_VERSION_NOT_SUPPORTED: 505,
    INSUFFICIENT_SPACE_ON_RESOURCE: 419,
    INSUFFICIENT_STORAGE: 507,
    INTERNAL_SERVER_ERROR: 500,
    LENGTH_REQUIRED: 411,
    LOCKED: 423,
    METHOD_FAILURE: 420,
    METHOD_NOT_ALLOWED: 405,
    MOVED_PERMANENTLY: 301,
    MOVED_TEMPORARILY: 302,
    MULTI_STATUS: 207,
    MULTIPLE_CHOICES: 300,
    NO_CONTENT: 204,
    NON_AUTHORITATIVE_INFORMATION: 203,
    NOT_ACCEPTABLE: 406,
    NOT_FOUND: 404,
    NOT_IMPLEMENTED: 501,
    NOT_MODIFIED: 304,
    OK: 200,
    PARTIAL_CONTENT: 206,
    PAYMENT_REQUIRED: 402,
    PRECONDITION_FAILED: 412,
    PROCESSING: 102,
    PROXY_AUTHENTICATION_REQUIRED: 407,
    REQUEST_TIMEOUT: 408,
    REQUEST_TOO_LONG: 413,
    REQUEST_URI_TOO_LONG: 414,
    REQUESTED_RANGE_NOT_SATISFIABLE: 416,
    RESET_CONTENT: 205,
    SEE_OTHER: 303,
    SERVICE_UNAVAILABLE: 503,
    SWITCHING_PROTOCOLS: 101,
    TEMPORARY_REDIRECT: 307,
    UNAUTHORIZED: 401,
    UNPROCESSABLE_ENTITY: 422,
    UNSUPPORTED_MEDIA_TYPE: 415,
    USE_PROXY: 305,
    ELASTICSEARCH: 306,
    SERVER_UNRESPONSIVE: 0,
    EARLY_HINTS: 103
};
const statusCodes = {};
statusCodes[UtilHttpStatus.ACCEPTED] = 'Accepted';
statusCodes[UtilHttpStatus.BAD_GATEWAY] = 'Bad Gateway';
statusCodes[UtilHttpStatus.BAD_REQUEST] = 'Bad Request';
statusCodes[UtilHttpStatus.CONFLICT] = 'Conflict';
statusCodes[UtilHttpStatus.CONTINUE] = 'Continue';
statusCodes[UtilHttpStatus.CREATED] = 'Created';
statusCodes[UtilHttpStatus.EXPECTATION_FAILED] = 'Expectation Failed';
statusCodes[UtilHttpStatus.FORBIDDEN] = 'Forbidden';
statusCodes[UtilHttpStatus.GATEWAY_TIMEOUT] = 'Gateway Timeout';
statusCodes[UtilHttpStatus.GONE] = 'Gone';
statusCodes[UtilHttpStatus.HTTP_VERSION_NOT_SUPPORTED] = 'HTTP Version Not Supported';
statusCodes[UtilHttpStatus.INSUFFICIENT_SPACE_ON_RESOURCE] = 'Insufficient Space on Resource';
statusCodes[UtilHttpStatus.INSUFFICIENT_STORAGE] = 'Insufficient Storage';
statusCodes[UtilHttpStatus.INTERNAL_SERVER_ERROR] = 'Server Error';
statusCodes[UtilHttpStatus.LENGTH_REQUIRED] = 'Length Required';
statusCodes[UtilHttpStatus.LOCKED] = 'Locked';
statusCodes[UtilHttpStatus.METHOD_FAILURE] = 'Method Failure';
statusCodes[UtilHttpStatus.METHOD_NOT_ALLOWED] = 'Method Not Allowed';
statusCodes[UtilHttpStatus.MOVED_PERMANENTLY] = 'Moved Permanently';
statusCodes[UtilHttpStatus.MOVED_TEMPORARILY] = 'Moved Temporarily';
statusCodes[UtilHttpStatus.MULTI_STATUS] = 'Multi-Status';
statusCodes[UtilHttpStatus.MULTIPLE_CHOICES] = 'Multiple Choices';
statusCodes[UtilHttpStatus.NO_CONTENT] = 'No Content';
statusCodes[UtilHttpStatus.NON_AUTHORITATIVE_INFORMATION] = 'Non Authoritative Information';
statusCodes[UtilHttpStatus.NOT_ACCEPTABLE] = 'Not Acceptable';
statusCodes[UtilHttpStatus.NOT_FOUND] = 'Not Found';
statusCodes[UtilHttpStatus.NOT_IMPLEMENTED] = 'Not Implemented';
statusCodes[UtilHttpStatus.NOT_MODIFIED] = 'Not Modified';
statusCodes[UtilHttpStatus.OK] = 'OK';
statusCodes[UtilHttpStatus.PARTIAL_CONTENT] = 'Partial Content';
statusCodes[UtilHttpStatus.PAYMENT_REQUIRED] = 'Payment Required';
statusCodes[UtilHttpStatus.PRECONDITION_FAILED] = 'Precondition Failed';
statusCodes[UtilHttpStatus.PROCESSING] = 'Processing';
statusCodes[UtilHttpStatus.PROXY_AUTHENTICATION_REQUIRED] = 'Proxy Authentication Required';
statusCodes[UtilHttpStatus.REQUEST_TIMEOUT] = 'Request Timeout';
statusCodes[UtilHttpStatus.REQUEST_TOO_LONG] = 'Request Entity Too Large';
statusCodes[UtilHttpStatus.REQUEST_URI_TOO_LONG] = 'Request-URI Too Long';
statusCodes[UtilHttpStatus.REQUESTED_RANGE_NOT_SATISFIABLE] = 'Requested Range Not Satisfiable';
statusCodes[UtilHttpStatus.RESET_CONTENT] = 'Reset Content';
statusCodes[UtilHttpStatus.SEE_OTHER] = 'See Other';
statusCodes[UtilHttpStatus.SERVICE_UNAVAILABLE] = 'Service Unavailable';
statusCodes[UtilHttpStatus.SWITCHING_PROTOCOLS] = 'Switching Protocols';
statusCodes[UtilHttpStatus.TEMPORARY_REDIRECT] = 'Temporary Redirect';
statusCodes[UtilHttpStatus.UNAUTHORIZED] = 'Unauthorized';
statusCodes[UtilHttpStatus.UNPROCESSABLE_ENTITY] = 'Unprocessable Entity';
statusCodes[UtilHttpStatus.UNSUPPORTED_MEDIA_TYPE] = 'Unsupported Media Type';
statusCodes[UtilHttpStatus.USE_PROXY] = 'Use Proxy';
statusCodes[UtilHttpStatus.ELASTICSEARCH] = 'Error - search is not running. Please contact a system administrator to configure it';
statusCodes[UtilHttpStatus.SERVER_UNRESPONSIVE] = 'Aborted/Timed out request: Server is down or client not connected.';
statusCodes[UtilHttpStatus.EARLY_HINTS] = 'Early Hints';
function getStatusText(statusCode) {
    if (statusCodes.hasOwnProperty(statusCode)) {
        return statusCodes[statusCode];
    }
    else {
        throw new Error('Status code does not exist: ' + statusCode);
    }
}
UtilHttpStatus.getStatusText = getStatusText;
